import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import EditProfile from './EditProfile';
import { connect } from 'react-redux';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`vertical-tabpanel-${index}`}
			aria-labelledby={`vertical-tab-${index}`}
			{...other}>
			{value === index && <Box>{children}</Box>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `vertical-tab-${index}`,
		'aria-controls': `vertical-tabpanel-${index}`,
	};
}

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
		display: 'flex',
		height: 'auto',
		padding: '2em',
	},
	tabs: {
		borderRight: `1px solid ${theme.palette.divider}`,
	},
	container: {
		marginTop: '1.5rem',
	},
	tabPanel: {
		width: '80%',
		paddingLeft: '2.5em',
	},
}));

function VerticalTabs() {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<>
			<CssBaseline />
			<Container maxWidth='md' className={classes.container}>
				<div className={classes.root}>
					<Tabs
						orientation='vertical'
						variant='scrollable'
						value={value}
						onChange={handleChange}
						aria-label='Vertical tabs example'
						className={classes.tabs}>
						<Tab label='Edit Profile' {...a11yProps(0)} />
					</Tabs>
					<TabPanel className={classes.tabPanel} value={value} index={0}>
						<EditProfile />
					</TabPanel>
				</div>
			</Container>
		</>
	);
}
export default connect(null)(VerticalTabs);
